(function () {
  var _origFetch = window.fetch;
  window.fetch = function (resource, options) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url ? resource.url : '');
    if (url.indexOf('/cart/add') !== -1 && options && options.body && typeof options.body === 'string') {
      try {
        var body = JSON.parse(options.body);
        var costs = window.ashDelivery || {};
        function inject(item) {
          var cost = costs[item.id];
          if (cost !== undefined && cost !== null && String(cost) !== '') {
            if (!item.properties) item.properties = {};
            if (!item.properties['הובלה/הרכבה'])
              item.properties['הובלה/הרכבה'] = String(cost) + ' ₪ (תשלום למוביל)';
          }
        }
        if (Array.isArray(body.items)) { body.items.forEach(inject); options = Object.assign({}, options, { body: JSON.stringify(body) }); }
        else if (body.id) { inject(body); options = Object.assign({}, options, { body: JSON.stringify(body) }); }
      } catch (e) {}
    }
    return _origFetch.apply(this, arguments);
  };

  document.addEventListener('DOMContentLoaded', function () {
    function formatDelivery(cost) {
      return cost !== undefined && cost !== null && String(cost) !== ''
        ? String(cost) + ' ₪ (תשלום למוביל)'
        : '';
    }
    function updateDelivery(variantId, form) {
      var d = form ? form.querySelector('[name="properties[הובלה/הרכבה]"]') : document.querySelector('[name="properties[הובלה/הרכבה]"]');
      if (!d) return;
      d.value = formatDelivery((window.ashDelivery || {})[variantId]);
    }

    // Set initial value on page load
    document.querySelectorAll('.product-variant-id').forEach(function (input) {
      var f = input.closest('form');
      updateDelivery(input.value, f);

      new MutationObserver(function () { updateDelivery(input.value, f); }).observe(input, { attributes: true, attributeFilter: ['value'] });
      input.addEventListener('change', function () { updateDelivery(this.value, f); });
    });

    document.addEventListener('variant:change', function (e) {
      if (!e.detail || !e.detail.variant) return;
      updateDelivery(e.detail.variant.id, e.target ? e.target.closest('form') : null);
    });
  });
})();